import { BoosterandBlockerPageCard } from '@screens/HomePage/MyBoosterandBlockerPage/BosterandBlockerPageCard';
import { ReturnButton } from '@/components/shared/ReturnButton';
import { useGetNutritionSummaryListV2 } from '@viome/viome-base/src/usecase/Home/HomeQuery';
import { Skeleton } from '@design-system/Skeleton';
import { cn } from '@/utils/styles';
import { ErrorLoadingPage } from '@screens/ErrorHandling/ErrorLoadingPage';

export const BoostersAndBlockersPage = () => {
  const {
    data: nutritionSummaryListData,
    isLoading,
    isError,
  } = useGetNutritionSummaryListV2();

  const sortedNutritionSummaryList = nutritionSummaryListData?.sort(
    (a, b) => a.ordinal - b.ordinal,
  );

  if (isError) {
    return <ErrorLoadingPage />;
  }

  if (isLoading) {
    return (
      <section className="page-container" data-testid="boostersBlockersLanding-loadingPage">
        <div className="min-h-screen bg-background-secondary" data-testid="boostersBlockersLanding-loadingContainer">
          <div className="p-6" data-testid="boostersBlockersLanding-loadingHeader">
            <ReturnButton data-testid="boostersBlockersLanding-loadingReturnButton" />

            <h1 className="typography-d2 text-primary mt-10" data-testid="boostersBlockersLanding-loadingTitle">
              My Boosters & Blockers
            </h1>
          </div>

          <div className="px-6" data-testid="boostersBlockersLanding-loadingGrid">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-2" data-testid="boostersBlockersLanding-loadingCardsGrid">
              {Array.from({ length: 8 }).map((_, index) => (
                <Skeleton
                  key={index}
                  className={cn('w-full h-20 rounded-md animate-pulse')}
                  data-testid={`boostersBlockersLanding-loadingSkeleton-${index}`}
                />
              ))}
            </div>
          </div>
        </div>
      </section>
    );
  }

  if (!nutritionSummaryListData?.length) {
    return;
  }

  return (
    <section className="page-container" data-testid="boostersBlockersLanding-page">
      <div className="min-h-screen bg-background-secondary" data-testid="boostersBlockersLanding-container">
        <div className="p-6" data-testid="boostersBlockersLanding-header">
          <ReturnButton data-testid="boostersBlockersLanding-returnButton" />

          <h1 className="typography-d2 text-primary mt-10" data-testid="boostersBlockersLanding-title">
            My Boosters & Blockers
          </h1>
        </div>

        <div className="px-6" data-testid="boostersBlockersLanding-content">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-2" data-testid="boostersBlockersLanding-cardsGrid">
            {sortedNutritionSummaryList?.map((item, index) => (
              <BoosterandBlockerPageCard
                key={item.id}
                id={item.id}
                title={item.title}
                count={item.no_of_recommendations}
                imageUrl={item.image_url}
                data-testid={`boostersBlockersLanding-card-${index}`}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
